import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  IconButton,
  Link,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Tooltip,
} from '@material-ui/core';
import FindReplaceIcon from '@material-ui/icons/PeopleOutline';

import { CustomSVG, Numeric } from 'components';
import { useCurrentUser } from 'hooks';
import { people as peoplePath } from 'paths';
import { generateLink, People } from 'Links';

import useStyles from './itemStyles';

const ClientFollowers: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { id, follower_count } = useCurrentUser();

  function renderFollowers() {
    if (!follower_count) {
      return (
        <Tooltip arrow title={t('components:findPeople')} placement="top">
          <IconButton component={People} className={classes.iconButton}>
            <FindReplaceIcon className={classes.peopleIcon} />
          </IconButton>
        </Tooltip>
      );
    }

    return (
      <Link component={generateLink(`/profile/${id}/followers`)} color="textSecondary">
        <Numeric value={follower_count} />
      </Link>
    );
  }

  return (
    <ListItem disableGutters classes={{ secondaryAction: classes.secondaryAction }}>
      <ListItemIcon className={classes.listIcon}>
        <CustomSVG size={28} name="everyoneSocial" />
      </ListItemIcon>
      <ListItemText disableTypography className={classes.overflow}>
        <Link variant="body2" component={generateLink(peoplePath)}>
          {t('common:follower', { count: follower_count })}
        </Link>
      </ListItemText>
      <ListItemSecondaryAction>{renderFollowers()}</ListItemSecondaryAction>
    </ListItem>
  );
};

export default ClientFollowers;
